// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'

import styles from './SheetPreview.module.scss'

export const SheetPreview = ({ className = undefined, data = [] }) => {
  const keys = R.pipe(
    R.head,
    R.keys,
  )(data)

  return (
    <Box className={cx(styles.sheet, { [className]: Boolean(className) })}>
      <table className={styles.table}>
        <thead>
          <tr>
            {R.addIndex(R.map)(
              (header, index) => (
                <th className={styles.cell} key={index}>
                  {header}
                </th>
              ),
              keys,
            )}
          </tr>
        </thead>
        <tbody>
          {R.addIndex(R.map)(
            (row, index) => (
              <tr key={index}>
                {R.pipe(
                  R.values,
                  R.addIndex(R.map)((value, idx) => (
                    <td className={styles.cell} key={idx}>
                      {value}
                    </td>
                  )),
                )(row)}
              </tr>
            ),
            data,
          )}
        </tbody>
      </table>
    </Box>
  )
}
